const sampleQuestions = [
  'What does error code CFG.001.06 mean?',
  'What are the dimensions of a TAMXB0A24V21DB air handler?',
  'What does error code ERR.022.00 mean?'
]

export default sampleQuestions
